import { useMemo } from 'react';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { AVOID_DEACTIVATION_BANNER_HEIGHT as BANNER_HEIGHT } from '@atlassian/auto-upgrade-not-a-trial';
import { BANNER_NAME } from '../../constants.tsx';
import { useEligibilityCriteria } from '../../services/use-eligibility-criteria/index.tsx';
import { useAutoUpgradeTrait } from '../../services/use-auto-upgrade-trait/index.tsx';

export const useBannerAutoUpgradeNotATrial = () => {
	const { isEligible, projectType } = useEligibilityCriteria();
	const { productTrait } = useAutoUpgradeTrait({ projectType });
	const [expConfig] = UNSAFE_noExposureExp('auto_upgrade_not_a_trial');
	const cohort = expConfig.get('cohort', 'not-enrolled');

	const isEnabled = Boolean(
		isEligible && projectType && productTrait?.value && cohort === 'treatment',
	);

	return useMemo(
		() => ({
			isEnabled,
			name: BANNER_NAME,
			height: isEnabled ? BANNER_HEIGHT : 0,
		}),
		[isEnabled],
	);
};
